module.exports = {"230717001":"朝阳街道","230717002":"前进街道","230717003":"红升街道","230717004":"旭日街道","230717005":"新欣街道","230717006":"南郡街道","230717100":"东升镇","230717101":"美溪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230717.json
// module id = 845
// module chunks = 0